








import Vue from 'vue';
import MainHeader from '@/components/header/MainHeader.vue';
import MainMobileHeader from '@/components/header/MainMobileHeader.vue';

export default Vue.extend({
    components: {
        MainHeader,
        MainMobileHeader,
    },
    data() {
        return {
            scrollListener: null as any,
        };
    },
    mounted() {
        this.scrollListener = () => {
            const sd: any = document.getElementById('brand-detail-main');
            if ((sd && sd.offsetTop - window.scrollY > 145) || (window.scrollY < 120)) { // 头部的品牌信息没过导航栏时，显示
                this.$store.commit('showSearchBar');
            } else {
                this.$store.commit('hideSearchBar');
            }
        };
        window.addEventListener('scroll', this.scrollListener);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollListener);
    },
});
